import React, { Component } from "react"
import "./miSaldo.css";

export class MiSaldoCard extends Component {



    EnvioToken = async (token, idServicio, IdPort, matricula) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        if(matricula){
            var raw = JSON.stringify({
                "token": token,
                "idPortal": IdPort,
                "idServicio": idServicio,
                "matricula": matricula
            });
        }else{
            var raw = JSON.stringify({
                "token": token,
                "idPortal": IdPort,
                "idServicio": idServicio
            });
        }

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        await fetch("https://misaldo.tecmilenio.mx/api/Saldos/recepcionToken", requestOptions)
            .then(response => response.json())
            .then(result => {

                this.setState({
                    fechaCorte: result.fechaCorte,
                    fechaLimitePago: result.fechaLimitePago,
                    saldoTotal: result.saldoTotal,
                    saldoAnterior: result.saldoAnterior,
                    matricula: result.matricula,
                    nombre: result.nombreCompleto,
                    email: result.correoAlumno,
                    campus: result.campusAlumno,
                    term: result.term,
                    urlConsulta: result.urlConsulta,
                    botonBloqueoDomiciliar: false,
                    botonBloqueoPago: false,
                    botonSpinner: "",
                    radioDis: false

                })
                localStorage.setItem('matricula',result.matricula);

                setTimeout(() => {
                    if (this.state.saldoTotal > 0) {

                        this.setState({ botonBloqueoPago: false })
                    } else {
                        console.log("No entro", this.state.saldoTotal)
                        console.log("state", this.state)
                        this.setState({ botonBloqueoPago: true })
                        this.setState({ saldoFavor: "Saldo total a favor" })
                    }
                }, 250);

            })
            .catch(error => console.log('error', error));

    }
    constructor(props) {
        super(props);
        const query = new URLSearchParams(window.location.search);
        // Se debe hacer el get con el nombre del parametro de la url
        let urlParam = query.get("token");
        let urlParamIdServ = query.get("idServicio");
        let urlParamIdPort = query.get("idPortal");
        let matricula = localStorage.getItem('matricula');
        this.state = {
            saldoFavor: "Saldo total",
            radioDis: true,
            fechaCorte: "",
            fechaLimitePago: "",
            saldoTotal: "",
            saldoAnterior: "",
            matricula: "",
            nombre: "",
            campus: "",
            montoInicial: "",
            cantidad: "",
            codigoTienda: "",
            cvetienda: "",
            llaveTienda: "",
            folioTienda: "",
            tipoMoneda: "",
            servicio: "",
            tipoTransaccion: "",
            descServicio: "",
            idioma: "",
            email: "",
            urlRegreso: "",
            urlAviso: "",
            opcional: "",
            q: "",
            term:"",
            termEncrp: "",
            matriculaEncrp: "",
            campusEncrp: "",
            emailEncrp: "",
            nombreEncr: "",
            botonBloqueoPago: true,
            botonBloqueoDomiciliar: true,
            botonSpinner: "spinner-border spinner-border-sm",
            colorCero: "",
            urlConsulta: "",
            
            checkRadio: "pagoCompleto",
        }
        this.EnvioToken(urlParam, urlParamIdServ, urlParamIdPort, matricula);
    }

    CambioRadio = (event) => {

        this.setState({ checkRadio: event.target.value });
        if (event.target.value === "pagoCompleto") {
            if (this.state.saldoTotal > 0) {
                this.setState({ botonBloqueoPago: false })
            } else {
                this.setState({ botonBloqueoPago: true })
            }
        }
        else {
            if (document.getElementById("inpSaldoParcial").value > 0) {
                this.setState({ botonBloqueoPago: false })
            } else {
                this.setState({ botonBloqueoPago: true })
            }
        }
    }
    ChangeCantidad = (event) => {

        if (this.state.checkRadio === "pagoParcial" && event.target.value > 0) {
            this.setState({ botonBloqueoPago: false })
        } else {
            this.setState({ botonBloqueoPago: true })
        }
    }

    EnvioCheckOut = (event) => {
        if (event.target.id == "btnCho" && document.getElementById("PagoParcial").checked == true && document.getElementById("inpSaldoParcial").value <= 0) {
            this.setState({
                colorCero: "background-color: #FFD700"
            })

        } else {
            this.setState({
                botonBloqueoPago: true,
                botonBloqueoDomiciliar: true,
                botonSpinner: "spinner-border spinner-border-sm",
                colorCero: ""
            })
            var myHeaders = new Headers();
            var raw = ""

            myHeaders.append("Content-Type", "application/json");
            if (document.getElementById("PagoParcial").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": document.getElementById("inpSaldoParcial").value,
                    "Term": this.state.term,
                    "Total": false,
                    "PrestamoED": false,
                });
            } else if (document.getElementById("PagoCompleto").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": "0",
                    "Term": this.state.term,
                    "Total": true,
                    "PrestamoED": false
                });
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://misaldo.tecmilenio.mx/api/Saldos/Checkout", requestOptions)
                .then(response => response.json())
                .then(result => {

                    this.setState({
                        matriculaEncrp: result.matricula,
                        emailEncrp: result.email,
                        campusEncrp: result.campus,
                        nombreEncr: result.nombre,
                        montoInicial: result.montoInicial,
                        cantidad: result.cantidad,
                        codigoTienda: result.codigoTienda,
                        cvetienda: result.cveTienda,
                        llaveTienda: result.llaveTienda,
                        folioTienda: result.folioTienda,
                        tipoMoneda: result.tipoMoneda,
                        servicio: result.servicio,
                        tipoTransaccion: result.tipoTransaccion,
                        descServicio: result.descServicio,
                        idioma: result.idioma,
                        urlRegreso: result.urlRegreso,
                        urlAviso: result.urlAviso,
                        opcional: result.opcional,
                        q: result.q,
                        termEncrp: result.term,
                        botonBloqueoPago: false,
                        botonBloqueoDomiciliar: false,
                        botonSpinner: ""


                    })
                    if (event.target.id == "btnCho") {
                        setTimeout(() => { document.getElementById("FormCheckOut").submit() }, 250);
                    } else if (event.target.id == "btnDmi") {
                        setTimeout(() => { document.getElementById("FormDom").submit() }, 250);
                    }




                })
                .catch(error => console.log('error', error));
        }
    }

    render() {
        return (

            <div>
                <div className="container mt-5">
                    <div className="card">
                        <div className="card-header headerCard rounded-top">
                            <div className="row">
                                <div className="headerMiSaldo col-10">
                                    <h2 className="titleHeader">Mi Saldo</h2>
                                    <h6 className="titleHeader">Resumen de mi Estado de Cuenta</h6>
                                </div>
                                <div className="iconHeader col">
                                    <i className="bi bi-three-dots-vertical iconDots"></i>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="card-header navSection">
                                <ul className="nav nav-tabs card-header-tabs">
                                    <li className="nav-item">
                                        <a className="nav-link active" href=""> TecMilenio </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={this.state.linkPrestamo}> Préstamo Educativo </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="billSection">
                                <div className="billRow row billRowMain">
                                    <div className="col-6 ">
                                        <p>{this.state.saldoFavor}</p>
                                    </div>
                                    <div className="col-6 payInfo">
                                        <h6>${this.state.saldoTotal}</h6>
                                    </div>
                                </div>
                                <div className="billRow">
                                    <div className="billRow row">
                                        <div className="col-6">
                                            <h6 className="infoDisplay">Saldo a pagar</h6>
                                            <span id="interest">para no generar intereses</span>
                                        </div>
                                        <div className="col-6 payInfo">
                                            <h6>${this.state.saldoAnterior}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="billRow">
                                    <div className="billRow row mt-3">
                                        <div className="col-6">
                                            <p className="infoDisplay mb-2">Fecha de corte</p>
                                            <p>Fecha límite de pago</p>
                                        </div>
                                        <div className="col-6 payDate">
                                            <h6>{this.state.fechaCorte}</h6>
                                            <h6>{this.state.fechaLimitePago}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="billRow">
                                    <div className="billRow row">
                                        <div className="accountState">
                                            <a className="link-success" target="_blank" rel="noreferrer noopener" href={this.state.urlConsulta}>Ver estado de cuenta</a>
                                            <i className="bi bi-arrow-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="paySection">
                                <div>
                                    <div>
                                        <p>Pagar</p>
                                    </div>
                                </div>
                                <div className="amountSection row">
                                    <div className="amountCheckBox col-6">
                                        <input type="radio" disabled={this.state.radioDis} name="pago" id="PagoCompleto" value="pagoCompleto" onChange={this.CambioRadio} checked={this.state.checkRadio === "pagoCompleto"} aria-label="Radio button for following text input" className="mt-1" />
                                        <h6 className="textPay">Total a pagar:</h6>
                                    </div>
                                    <div className="amountCheckBox col-6">
                                        <input type="radio" disabled={this.state.radioDis} name="pago" id="PagoParcial" value="pagoParcial" onChange={this.CambioRadio} checked={this.state.checkRadio === "pagoParcial"} aria-label="Radio button for following text input" className="mt-1"  /*onSelect={selectRadio}*/ />
                                        <h6 className="textPay">Otra cantidad:</h6>
                                    </div>
                                </div>
                                <div className="amountSection row mb-3">
                                    <div className="amountCheckBoxPay col-6">
                                        <h6>${this.state.saldoAnterior}</h6>
                                    </div>
                                    <div className="amountCheckBox col-6">
                                        <input type="number" id="inpSaldoParcial" onChange={this.ChangeCantidad} className="form-control otherAmount" placeholder="$0.00" />
                                        <div className="dropdown">
                                            <button className="btn payOption btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> MXN </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="payButtons">
                                    <div className="payButton">
                                        <form action="https://checkoutpprd.tec.mx/PostTienda/Index" target="_blank" method="POST" id="FormCheckOut">
                                            <input type="input" readOnly value={this.state.matriculaEncrp} id="CheckOutMat" name="matricula" hidden />
                                            <input type="input" readOnly value={this.state.nombreEncr} id="CheckOutNom" name="nombre" hidden />
                                            <input type="input" readOnly value={this.state.campusEncrp} id="CheckOutCamp" name="campus" hidden />
                                            <input type="input" readOnly value={this.state.montoInicial} id="CheckOutMontIn" name="montoInicial" hidden />
                                            <input type="input" readOnly value={this.state.cantidad} id="CheckOutCant" name="cantidad" hidden />
                                            <input type="input" readOnly value={this.state.codigoTienda} id="CheckOutCodTi" name="codigoTienda" hidden />
                                            <input type="input" readOnly value={this.state.cvetienda} id="CheckOutCVETi" name="cvetienda" hidden />
                                            <input type="input" readOnly value={this.state.llaveTienda} id="CheckOutLlaveTi" name="llaveTienda" hidden />
                                            <input type="input" readOnly value={this.state.folioTienda} id="CheckOutFolTi" name="folioTienda" hidden />
                                            <input type="input" readOnly value={this.state.tipoMoneda} id="CheckOutTipMoneda" name="tipoMoneda" hidden />
                                            <input type="input" readOnly value={this.state.servicio} id="CheckOutServ" name="servicio" hidden />
                                            <input type="input" readOnly value={this.state.tipoTransaccion} id="CheckOutTipoTra" name="tipoTransaccion" hidden />
                                            <input type="input" readOnly value={this.state.descServicio} id="CheckOutDescServ" name="descServicio" hidden />
                                            <input type="input" readOnly value={this.state.idioma} id="CheckOutIdio" name="idioma" hidden />
                                            <input type="input" readOnly value={this.state.emailEncrp} id="CheckOutEmail" name="email" hidden />
                                            <input type="input" readOnly value={this.state.urlRegreso} id="CheckOutUrlRe" name="urlRegreso" hidden />
                                            <input type="input" readOnly value={this.state.urlAviso} id="CheckOutUrlAv" name="urlAviso" hidden />
                                            <input type="input" readOnly value={this.state.opcional} id="CheckOutOpc" name="opcional" hidden />
                                            <input type="input" readOnly value={this.state.q} id="CheckOutQ" name="q" hidden />
                                            <input type="input" readOnly value={this.state.termEncrp} id="CheckOutTerm" name="term" hidden /> {/* <button type="submit">enviar</button> */}
                                            <button id="btnCho" type="button" onClick={this.EnvioCheckOut} disabled={this.state.botonBloqueoPago} className="btn btnEnd btn-success"> Proceder al pago <span className={this.state.botonSpinner}></span> </button>
                                        </form>
                                    </div>
                                    <div className="payButton">
                                        <form id="FormDom" action="https://domiciliacion.tec.mx/PostTienda/Domiciliacion" method="POST" target="_blank">
                                            <input type="input" hidden readOnly value={this.state.matriculaEncrp} id="DomiOutMat" name="matricula" />
                                            <input type="input" hidden readOnly value={this.state.nombreEncr} id="DomiOutNom" name="nombre" />
                                            <input type="input" hidden readOnly value={this.state.codigoTienda} id="DomiOutCodTi" name="codigoTienda" />
                                            <input type="input" hidden readOnly value={this.state.cvetienda} id="DomiOutCVETi" name="cvetienda" />
                                            <input type="input" hidden readOnly value={this.state.llaveTienda} id="DomiOutLlaveTi" name="llaveTienda" />
                                            <input type="input" hidden readOnly value={this.state.servicio} id="DomiOutServ" name="servicio" />
                                            <input type="input" hidden readOnly value={this.state.tipoTransaccion} id="DomiOutTipoTran" name="tipoTransaccion" />
                                            <input type="input" hidden readOnly value={this.state.idioma} id="DomiOutIdio" name="idioma" />
                                            <input type="input" hidden readOnly value={this.state.emailEncrp} id="DomiOutCorreo" name="email" />
                                            <input type="input" hidden readOnly value={this.state.urlRegreso} id="DomiOuturlRegreso" name="urlRegreso" /> {/* <button type="submit">enviar</button> */}
                                            <button id="btnDmi" type="button" onClick={this.EnvioCheckOut} disabled={this.state.botonBloqueoDomiciliar} className="btn btnEnd btn-outline-secondary"> Domiciliar <span className={this.state.botonSpinner}></span> </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
